<template>
  <div class="SearchInput">
    <div class="SearchInput-search w-[300px] flex rounded-3xl overflow-hidden shadow-lg">
      <el-input
        @focus="showFilter = !showPannelKey"
        size="large"
        v-model="searchValue"
        clearable
        placeholder="请输入关键字搜索"
      />
      <el-button @click="searchClickHandle" size="large" type="primary">
        <el-icon :size="18"><Search /></el-icon>
      </el-button>
    </div>

    <div v-if="showFilter" class="SearchInput-filter">
      <div class="SearchInput-filter-headre">
        <span>筛选条件</span>
        <el-icon @click="showFilter = false" style="cursor: pointer" color="#c0c7d9" :size="18"
          ><Close
        /></el-icon>
      </div>
      <div class="SearchInput-filter-block">
        <div
          v-for="t in widgetBtnList"
          :key="t.key"
          :class="activeItem === t.key ? 'active_item' : ''"
          class="SearchInput-filter-block-item"
          @click="clickCheck(t.key)"
        >
          {{ t.name }}
        </div>
      </div>

      <div v-if="searchHistoryList.length" class="SearchInput-filter-history">
        <el-divider style="margin: 0" />
        <div
          @click="historyListClick(t)"
          v-for="(t, i) in searchHistoryList"
          :key="i"
          class="SearchInput-filter-history-item"
        >
          <div>
            <el-icon :size="13"><Clock /></el-icon>
            <span>{{ t }}</span>
          </div>
          <el-icon @click.stop="removeSearchHistory(i)" :size="14"><Close /></el-icon>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref, watch } from 'vue'
import { Search, Clock, Close } from '@element-plus/icons-vue'
import { widgetBtnList } from './widgetOptions'

const SEARCH_HISTORY_KEY = 'searchHistory'

// 引入内容
const showPannelKey = defineModel<string>('bandKey')
// 搜索框
const searchValue = defineModel<string>('searchValue')

watch(showPannelKey, () => {
  showFilter.value = false
})

// 选中类型
const activeItem = ref('qb')

// 搜索框下拉框
const showFilter = ref(false)

const searchHistoryList = ref<string[]>(
  JSON.parse(localStorage.getItem(SEARCH_HISTORY_KEY) || '[]')
)

const clickCheck = (t: string) => {
  activeItem.value = t
  showPannelKey.value = activeItem.value
  searchClickHandle()
}

// 触发搜索事件
const emit = defineEmits(['searchHandle'])

/** 搜索事件   */
const searchClickHandle = () => {
  if (searchValue.value?.trim()) {
    const findIdx = searchHistoryList.value.findIndex((t) => t === searchValue.value)
    if (findIdx !== -1) {
      searchHistoryList.value.splice(findIdx, 1)
    }
    searchHistoryList.value.unshift(searchValue.value)
    localStorage.setItem(SEARCH_HISTORY_KEY, JSON.stringify(searchHistoryList.value))
  }

  showPannelKey.value = activeItem.value

  emit('searchHandle')
}

/** 搜索历史点击事件  */
const historyListClick = (txt: string) => {
  searchValue.value = txt
  searchClickHandle()
}

/** 删除搜索历史  */
const removeSearchHistory = (idx: number) => {
  searchHistoryList.value.splice(idx, 1)
  localStorage.setItem(SEARCH_HISTORY_KEY, JSON.stringify(searchHistoryList.value))
}
</script>

<style lang="scss" scoped>
.SearchInput {
  position: absolute;
  top: 16px;
  left: 16px;
  width: 360px;

  &-filter {
    margin-top: 12px;
    background-color: #fff;
    border-radius: 6px;
    box-sizing: border-box;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    height: calc(100% - 48px);
    box-sizing: border-box;

    &-headre {
      padding: 10px 10px 0px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      > span {
        font-size: 14px;
      }
    }

    &-block {
      padding: 10px 10px 6px;
      display: flex;
      flex-wrap: wrap;

      &-item {
        height: 38px;
        width: calc((100% / 4) - 12px);
        border: 1px solid #eee;
        border-radius: 5px;
        cursor: pointer;
        font-size: 13px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 6px;
        transition: all 0.1s;
      }

      .active_item {
        background-color: #3b82f6;
        color: #fff;
      }
    }

    &-history {
      flex: 1;
      overflow-y: auto;

      ::-webkit-scrollbar {
        width: 8px; /* 滚动条宽度 */
        height: 8px; /* 横向滚动条高度 */
      }
      ::-webkit-scrollbar-track {
        background: #f1f1f1; /* 滚动条轨道背景色 */
      }

      ::-webkit-scrollbar-thumb {
        background: #ddd; /* 滚动条滑块背景色 */
        border-radius: 4px; /* 滚动条滑块圆角 */
      }

      ::-webkit-scrollbar-thumb:hover {
        background: #ccc; /* 滚动条滑块悬停背景色 */
      }

      ::-webkit-scrollbar-button {
        display: none; /* 隐藏滚动条按钮 */
      }
      scrollbar-width: thin; /* 设置滚动条宽度为细 */
      scrollbar-color: #ddd #f1f1f1; /* 滚动条滑块和轨道颜色 */

      &-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        cursor: pointer;
        padding: 12px;

        &:hover {
          background-color: #eee;
        }
        > div {
          display: flex;
          align-items: center;
          > span {
            margin-left: 8px;
            font-size: 13px;
          }
        }
      }
    }
  }
}
</style>
